export default __webpack_public_path__ + "static/media/map-active.d50f3c28.svg";